import { Button, Drawer, Flex, rem, Textarea } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { transformationTooltips } from '../../../../../../consts/conditions';
import { useMutateTransformationNote } from '../../../../../../services/period.service';
import { toast } from 'react-hot-toast';

export const NoteDrawer = ({
  label,
  isOpen,
  onClose,
  value,
  autoNote,
  title,
  transformId,
  stepId,
  onSubmit
}) => {
  // Prioritize custom note over auto_note, fall back to default tooltip
  const initialValue = value || autoNote || transformationTooltips[label];
  const [stateValue, setStateValue] = useState(initialValue);

  const inputRef = useRef(null);

  const mutateTransformationNote = useMutateTransformationNote();

  useEffect(() => {
    const newValue = value || autoNote || transformationTooltips[label];
    setStateValue(newValue);
  }, [value, autoNote, label]);

  useEffect(() => {
    let timeoutId;
    if (isOpen) {
      timeoutId = setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
    return () => clearTimeout(timeoutId);
  }, [isOpen]);

  const handleSubmit = () => {
    mutateTransformationNote.mutate(
      {
        data: {
          note: stateValue
        },
        transformId: transformId,
        stepId: stepId
      },
      {
        onSuccess: () => {
          toast.success('Note updated successfully');
          onClose();
          onSubmit();
        },
        onError: () => {
          toast.error('Failed to update note');
        }
      }
    );
  };

  return (
    <Drawer
      id="grid-table-note-drawer"
      opened={isOpen}
      onClose={onClose}
      title={title}
      w={rem(400)}
      position="right"
      withOverlay={false}
    >
      <Flex id="grid-table-note-drawer-content" direction="column" w="100%" gap={rem(48)}>
        <Textarea
          id="grid-table-note-textarea"
          ref={inputRef}
          rows={3}
          label="Your note"
          value={stateValue}
          autoFocus={isOpen}
          onChange={e => setStateValue(e.target.value)}
        />

        <Flex id="grid-table-note-actions" w="100%" justify="space-between" align="center">
          <Button
            id="grid-table-note-reset"
            disabled={stateValue === transformationTooltips[label]}
            size="sm"
            onClick={() => setStateValue(transformationTooltips[label])}
          >
            Reset to Default
          </Button>

          <Button
            id="grid-table-note-save"
            size="sm"
            onClick={handleSubmit}
            disabled={!stateValue || mutateTransformationNote.isLoading}
            loading={mutateTransformationNote.isLoading}
          >
            Save
          </Button>
        </Flex>
      </Flex>
    </Drawer>
  );
};
